import { actions } from "./modules";
import Utils from "../common/Utils";

class Router {
  store = {};
  history = window.History;
  isFirst = true;

  constructor(_store = {}) {
    this.store = _store;
    this.history.Adapter.bind(window, "statechange", () =>
      this.getParamSetData()
    );
    this.history.Adapter.trigger(window, "statechange");

    if (
      this.isFirst &&
      (Utils.getParamByName("skillid") || Utils.getParamByName("itemid"))
    ) {
      this.store.dispatch(actions.setUserselect(true));
      this.isFirst = false;
    }
  }

  getParamSetData() {
    this.findDispatch("query", actions.setQuery);
    this.findDispatch("itemid", actions.setItemid);
    this.findDispatch("skillid", actions.setSkillId);
    this.findDispatch("typesoper", actions.setTypesoperSel);
    this.findDispatch("type", actions.setTypeSel);
    this.findDispatch("lvmin", actions.setLvminSel);
    this.findDispatch("lvmax", actions.setLvmaxSel);
    this.findDispatch("raceid", actions.setRaceidSel);
    this.findDispatch("classid", actions.setClassidSel);
    this.findDispatch("grade", actions.setGradesSel);
    this.findDispatch("category", actions.setCategoriesSel);
    this.findDispatch("skilllevel", actions.setSkillLevel);
  }

  findDispatch(_key, _action) {
    let val = Utils.getParamByName(_key);
    if (val != null) this.store.dispatch(_action(val));
  }

  goSingleParam(_key, _val) {
    let initObj = {
      itemid: "",
      skillid: "",
    };
    let newObj = {};
    newObj[_key] = _val;
    this.goMultiParam($.extend(true, initObj, newObj));
  }

  goMultiParam(_newParamObj = {}) {
    let oldParamObj = {};
    document.location.search
      .substr(1)
      .split("&")
      .map((it) => {
        let key = it.split("=")[0];
        let val = it.split("=")[1];
        if (key === "query") {
          val = decodeURI(val);
        }

        oldParamObj[key] = val;
      });
    let lastParam = $.extend(true, oldParamObj, _newParamObj);
    this.changeParam($.param(lastParam));
  }

  goMultiParamSetListPage(_newParamObj = {}) {
    this.store.dispatch(actions.setStopListLoad(true));
    this.store.dispatch(actions.setListpage(1));

    this.goMultiParam(_newParamObj);

    this.store.dispatch(actions.setStopListLoad(false));
    this.store.dispatch(actions.loadItemList(1));
  }

  changeParam(_paramStr = "") {
    // let sever = (this.store.getState().config.tab==='lineage2')? '본서버':'각성서버';
    // let db = (this.store.getState().config.db==='item')? '아이템':'스킬';
    // let title = `${sever} ${db} 사전 : 리니지2`;
    // if(_device==='ingame') title = '리니지2 홈';
    const pageTitle = document.querySelector("title").textContent;
    this.history.pushState(null, pageTitle, "?" + _paramStr);
  }
} // end of class
export default Router;

/* 
    History.Adapter.bind(window,'statechange',function(){
        var State = History.getState();
    });
    History.pushState({state:1}, "State 1", "?state=1");
    History.replaceState({state:3}, "State 3", "?state=3");
    History.pushState(null, null, "?state=4");
    History.back();
    History.go(2);
*/
